import React from 'react';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';
import ServiceTypes from '../../components/ServiceTypes';
import serviceTypesData from '../../data/serviceTypes.json';
import ServiceInVictoria from '../../components/ServiceInVictoria';

const DrugCharges = () => {
  return (
    <div className="servicePage">
      <div className="servicePageContent">
        <div className="header">Drug Charges</div>
        <div className="body">
          <ServiceInVictoria
            header="Drug Charges in Victoria" 
            content="Drug offences in Victoria are taken very seriously and are governed by strict laws under the Drugs, Poisons and Controlled Substances Act 1981 (Vic). These laws cover a wide range of activities related to illicit drugs, including possession, trafficking, cultivation, manufacturing, and importing. Penalties for drug-related crimes vary depending on the nature and severity of the offence, with serious charges carrying substantial penalties, including imprisonment."
          />
          <ServiceTypes
            header="Types of Drug Charges"
            preamble="In Victoria, drug offences can be broadly categorized into the following:"
            typesJson={serviceTypesData["Drug Charges"]}
          />
          <ServiceDescriptionSection
            header="Drug Schedules and Classifications"
            content={
              <div>
                <div>Drugs in Victoria are classified into Schedules under the law, with each schedule listing controlled substances that are regulated or prohibited. The type and quantity of the drug significantly impact the severity of charges and penalties.</div>
                <ul>
                  <li>Schedule 1 Drugs: Includes highly dangerous and addictive substances such as heroin, methamphetamine (ice), and cocaine.</li>
                  <li>Covers less harmful substances like cannabis and certain prescription medications when used without proper authority.</li>
                </ul>
              </div>
            }
          />
          <ServiceDescriptionSection 
            header="Penalties for Drug Offences"
            content={
              <div>
                <div>Penalties for drug charges depend on the type of offence, the quantity of drugs, and whether the offence is deemed to be for personal use or commercial purposes. Key factors influencing penalties include:</div>
                <ul>
                  <li>Small vs. Large Quantity: Possession or trafficking of a small quantity may result in fines or diversion programs, while large quantities (considered commercial or traffickable amounts) can lead to more severe penalties.</li>
                  <li>Personal Use vs. Commercial: The intent behind possessing, manufacturing, or trafficking drugs can significantly affect the sentence. Offences for personal use carry lighter penalties, while commercial drug operations face more stringent consequences.</li>
                </ul>
              </div>
            }
          />
          <ServiceDescriptionSection
            header="Diversion Programs for Minor Drug Offences"
            content="For minor offences, such as possession of small amounts of cannabis or other drugs for personal use, first-time offenders may be eligible for a drug diversion program. This allows the offender to avoid a criminal record by participating in a treatment or rehabilitation program, which focuses on education and addressing drug-related issues."
          />
          <ServiceDescriptionSection
            header="Legal Defences for Drug Charges"
            content={
              <div>
                <div>There are several defences available for those facing drug charges in Victoria, including:</div>
                <ul>
                  <li><strong>Lack of knowledge:</strong> The accused was unaware that they had possession of the drugs.</li>
                  <li><strong>Mistaken identity:</strong> The drugs belonged to someone else.</li>
                  <li><strong>Improper police procedure:</strong> Any evidence obtained through unlawful search and seizure may be inadmissible in court.</li>
                </ul>
                <div>A skilled lawyer can assess the circumstances of the case and help develop a strong defence, whether to seek dismissal, reduce charges, or negotiate a plea deal.</div>
              </div>
            }
          />
          <ServiceLegalRepresentationRationale
            header="Why Legal Representation is Essential"
            content="Drug charges, especially those involving trafficking, cultivation, or large-scale possession, can have life-altering consequences, including lengthy prison terms, significant fines, and a criminal record that impacts future employment and travel opportunities. Legal representation is critical in navigating the complexities of drug laws, negotiating bail, and ensuring that your rights are protected throughout the legal process."
          />
          <ServiceContactUsSection
            header="Contact Us for Legal Assistance"
            content="If you or someone you know is facing drug charges in Victoria, our experienced legal team is here to help. We offer professional advice and representation, helping you understand your options and providing the best defence possible."
          />
        </div>
      </div>
    </div>
  );
};

export default DrugCharges;
